import React from 'react'

const useAlgebraButtonTheme = () => {
  const algebraButtonTheme = [
    {
      class: 'border-[1px] border-v8-line pb-2',
      buttons:
        'a1 a2 a3 a4 (□) a6 a7 % a8 del sin cos tan ± + - × ÷ = a9 a10 a11 &#960 ≤ ≥ < > a12 | . &#x222B space abc',
    },
    {
      class: 'bg-white',
      layout: 'hg-theme-default',
    },
    {
      class: 'text-white',
      buttons: 'del',
    },
    {
      class: 'w-[220px]',
      buttons: 'space',
    },
    {
      class: `bg-[url('/images/s1.png')] bg-no-repeat bg-center v-none`,
      buttons: 'a1',
    },
    {
      class: `bg-[url('/images/a12.png')] bg-no-repeat bg-center v-none`,
      buttons: 'a12',
    },
    {
      class: `bg-[url('/images/s2.png')] bg-no-repeat bg-center v-none`,
      buttons: 'a2',
    },
    {
      class: `bg-[url('/images/s3.png')] bg-no-repeat bg-center v-none`,
      buttons: 'a3',
    },
    {
      class: `bg-[url('/images/s4.png')] bg-no-repeat bg-center v-none`,
      buttons: 'a4',
    },
    {
      class: `bg-[url('/images/sqaure.png')] bg-no-repeat bg-center v-none`,
      buttons: 'a6',
    },
    {
      class: `bg-[url('/images/a7.png')] bg-no-repeat bg-center v-none`,
      buttons: 'a7',
    },
    {
      class: `bg-[url('/images/s5.png')] bg-no-repeat bg-center v-none`,
      buttons: 'a8',
    },
    {
      class: `bg-[url('/images/a9.png')] bg-no-repeat bg-center v-none`,
      buttons: 'a9',
    },
    {
      class: `bg-[url('/images/a10.png')] bg-no-repeat bg-center v-none`,
      buttons: 'a10',
    },
    {
      class: `bg-[url('/images/a11.png')] bg-no-repeat bg-center v-none`,
      buttons: 'a11',
    },

    {
      class: 'ms-[100px]',
      buttons: '&#x222B',
    },
    {
      class: 'ms-[15px]',
      buttons: 'a1 a10',
    },
    {
      class: 'me-[15px]',
      buttons: 'a9',
    },
    {
      class: 'me-[40px] bg-[#444CE7] text-white',
      buttons: 'abc',
    },
    {
      class: 'bg-[#FF692E]',
      buttons: 'del',
    },
    {
      class: 'bg-[#8098F9]',
      buttons: '{capslock}',
    },
    {
      class: 'bg-[#444CE7]',
      buttons: '&#946 &#x222B &#8730',
    },
    {
      class: 'text-white',
      buttons: '&#946 &#x222B &#8730 {capslock}',
    },
  ]

  return { algebraButtonTheme }
}

export default useAlgebraButtonTheme
